import PropTypes from 'prop-types';
import React from 'react';

const ReservationInfo = ({ barberName, serviceName, appointment, shop }) => (
  <dl>
    <dt className="c-heading c-heading--large">Professional:</dt>
    <dd className="c-heading c-heading--large u-mb">{barberName}</dd>
    <dt className="c-heading c-heading--large">Service:</dt>
    <dd className="c-heading c-heading--large u-type--capitalize u-mb">{serviceName}</dd>
    <dt className="c-heading c-heading--large">Time:</dt>
    <dd className="c-heading c-heading--large u-mb">{appointment.formatted}</dd>
    <dt className="c-heading c-heading--large">Duration:</dt>
    <dd className="c-heading c-heading--large u-mb">{appointment.formattedDuration}</dd>
    <dt className="c-heading c-heading--large">Shop:</dt>
    <dd className="c-heading c-heading--large">{shop.name}</dd>
    <dt className="c-heading c-heading--large">{shop.address}</dt>
    <dd className="c-heading c-heading--large u-mb+">{shop.zip}</dd>
  </dl>
);
ReservationInfo.propTypes = {
  barberName: PropTypes.string,
  serviceName: PropTypes.string,
  appointment: PropTypes.shape({
    start: PropTypes.string,
    formatted: PropTypes.string,
    formattedDuration: PropTypes.string,
  }),
  shop: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.string,
    zip: PropTypes.string,
    location: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
  }),
};
ReservationInfo.defaultProps = {
  barberName: '',
  serviceName: '',
  appointment: {},
  shop: {},
};
export default ReservationInfo;



// WEBPACK FOOTER //
// ./src/app/reservation/components/ReservationInfo.jsx